import * as React from 'react';

import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { setToDesktop } from '../../redux-state/actions/responsive';

interface DispatchToProps {
    setToDesktop: () => void;
}

type ResponsiveProps = DispatchToProps;

export class TransitionDesktopBase extends React.Component<ResponsiveProps, any> {

    componentDidMount() {
        this.props.setToDesktop();
    }

    /**
     * No need to render anything, since this component is about lifecycle events.
     */
    render() {
        return null
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToDesktop: () => dispatch(setToDesktop())
    }
}

export let ConnectedTransitionDesktop = connect<null, DispatchToProps>(null, mapDispatchToProps)(TransitionDesktopBase);